/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Flex, Text } from '@chakra-ui/react'
import { DescricaoCargo } from '../../../../../interfaces'

interface Props {
  cargos: DescricaoCargo[]
}

export const CustoSalarialMensal: React.FC<Props> = ({ cargos }) => {
  const total = cargos.flatMap(c => c.colaboradores || [])
    .filter(c => c.salario)
    .reduce((sum, c) => sum + (c.salario ?? 0), 0)

  const valorFormatado = total.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })

  return (
    <Flex
      flexDir="column"
      border={'1px solid var(--Azul)'}
      borderRadius={'.5rem'}
      p="1rem"
      minW="300px"
      flex="1"
      justify="center"
      align="center"
    >
      <Text fontWeight="500" mb=".5rem">Custo  atual em salários/mês</Text>
      <Text fontWeight="700" fontSize="1.75rem" color="var(--Azul)">{valorFormatado}</Text>
    </Flex>
  )
}
